// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3ayFK","footer":"ModalFilter_footer__LihzP"};